"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cantarana": {
    "dc9faff2": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "skipSearch": false
    }],
    "arboschio": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea199056": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "skipSearch": false
    }],
    "bricco-grosso": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d341344b": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "skipSearch": false
    }],
    "morra": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6482ffc": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "skipSearch": false
    }],
    "oca": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84cd75e5": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "skipSearch": false
    }],
    "regione-millefiori": [{
      "hkey": "dd155583",
      "slug": "cantarana",
      "name": "Cantarana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;